import React, { useEffect, useState } from "react";
import {
  Box,
  Stack,
  Typography,
} from "@mui/material";
import "./totalenrollment.scss";
import ReactApexChart from "react-apexcharts";
import { useQuery } from "@apollo/client";
import { AuthContext } from "../../../Context/AuthContext";
import { translateLauguage } from "../../../Function/Translate";
import { height, padding, style } from "@mui/system";
import { GET_ALL_ENROLLMENT_CHART } from "../../../Schema/Dashboard";

import LoadingPage from "../../Include/LoadingPage";

export default function TotalEnrollment({ academicYearId, academicYearName }) {
  // Change Language
  const { language } = React.useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [totalData, setTotalData] = useState([]);

  const [loading, setLoading] = useState(true);

  const { refetch } = useQuery(GET_ALL_ENROLLMENT_CHART, {
    variables: {
      academicYearId: academicYearId ?? null,
    },
    onCompleted: ({ getAllEnrollmentChart }) => {
      setTotalData(getAllEnrollmentChart);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const schoolData = totalData?.map((e) => {
    return language === "en" ? e?.schoolNameEn : e?.schoolName;
  });

  const totalStudent = totalData?.map((e) => e?.totalStudent)
  const totalFemale = totalData?.map((e) => e?.female)

  // const maxSeriesData = Math.max(...(totalStudent?.length ? totalStudent : []));

  useEffect(() => {
    refetch();
  }, [academicYearId]);

  // const [state, setState] = React.useState({
  //   series: [
  //     {
  //       name: "Total Students",
  //       data: [44, 55, 57],
  //       color: "#0071F1",
  //     },
  //     {
  //       name: "Female Students",
  //       data: [76, 85, 101],
  //       color: "#01B6CB",
  //     },
  //   ],
  //   options: {
  //     chart: {
  //       type: "bar",
  //       height: 350,
  //     },
  //     plotOptions: {
  //       bar: {
  //         horizontal: false,
  //         columnWidth: "55%",
  //         borderRadius: 5,
  //         borderRadiusApplication: "end",
  //       },
  //     },

  //     dataLabels: {
  //       enabled: true,
  //       style: {
  //         fontSize: "12px",
  //         colors: ["#304758"],
  //       },
  //       formatter: function (val) {
  //         return val === 0 ? 0 : val;
  //       },
  //     },
  //     stroke: {
  //       show: true,
  //       width: 2,
  //       colors: ["transparent"],
  //     },
  //     xaxis: {
  //       categories: [...schoolData],
  //     },
  //     yaxis: {
  //       title: {
  //         text: "សិក្សានុសិស្ស (នាក់)",
  //         style: {
  //           fontFamily: "Siemreap",
  //           fontSize: "12px",
  //         },
  //       },
  //     },
  //     fill: {
  //       opacity: 1,
  //     },
  //     tooltip: {
  //       y: {
  //         formatter: function (val) {
  //           return val + " នាក់";
  //         },
  //       },
  //     },
  //   },
  // });

  const state = {
    options: {
      chart: {
        type: "bar",
        height: 350,
        fontFamily: "Khmer OS Siemreap",
        stacked: false,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "50%",
          endingShape: "rounded",
          dataLabels: {
            position: "top", // top, center, bottom
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -25,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
        formatter: function (val, opts) {
          if (val > 0) {
            return val;
          } else {
            return "0";
          }
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: schoolData,
        labels: {
          rotate: -45, // Rotates labels to -45 degrees
          rotateAlways: true, // Ensures rotation applies
          maxHeight: 150,
        },
      },
      yaxis: {
        // max: maxSeriesData + 5,
        labels: {
          style: {
            fontFamily: "Siemreap",
          },
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            if (val > 0) {
              return val + " នាក់";
            } else {
              return 0 + " នាក់";
            }
          },
        },
      },
      fill: {
        opacity: 1,
      },
    },
    series: [
      {
        name: t("total_student"),
        data: totalStudent,
        color: "#0071F1",
      },
      {
        name: t("total_female"),
        data: totalFemale,
        color: "#01B6CB",
      },
    ],
  };

  return (
    <Box className="total-enrollment-chart" >
      <Stack direction="row" alignItems="center" justifyContent="center">
        <Typography
          className={language === "en" ? "chart-title" : "chart-title-kh"}
        >
          {t("total_enrollment")}{academicYearName && language === "kh" ? `ឆ្នាំសិក្សា ${academicYearName}` : ` ${academicYearName}`}
        </Typography>
      </Stack>

      {
        loading ? <LoadingPage /> :
          <div id="chart">
            <ReactApexChart
              options={state.options}
              series={state.series}
              type="bar"
              height={400}
            />
          </div>
      }
    </Box>
  );
}
